import { useEffect, useSyncExternalStore } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import type { RunStore } from '@inference.engine/agentic-react';
import { conversationSummariesQueryOptions } from '../api/queries';
import { AGENT_BUILDER_QUERY_KEYS } from '../api/query-keys';
import type { ConversationSummary } from '../api/conversation-summaries.api';

const NONE: ConversationSummary[] = [];

/**
 * Where a test conversation was summarized, read again whenever a turn reports a compaction on its
 * stream, which a debug turn waits for before it ends. Read nothing while `enabled` is off.
 */
export function useConversationSummaries(
  chatId: string,
  runStore: RunStore,
  enabled = true,
): ConversationSummary[] {
  const queryClient = useQueryClient();
  const summaries = useQuery({ ...conversationSummariesQueryOptions(chatId), enabled });
  const compacted = useSyncExternalStore(
    runStore.subscribe,
    () => runStore.getState().compactions.length,
  );
  useEffect(() => {
    if (compacted === 0) return;
    void queryClient.invalidateQueries({ queryKey: AGENT_BUILDER_QUERY_KEYS.summaries(chatId) });
  }, [compacted, chatId, queryClient]);
  return summaries.data ?? NONE;
}
